import { render, staticRenderFns } from "./BreakDetailsItem.vue?vue&type=template&id=59ef584c&"
import script from "./BreakDetailsItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BreakDetailsItem.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BreakDetailsItem.vue?vue&type=style&index=0&id=59ef584c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports